/* globals App, ca, eco */
import { mediaImageFilters } from '@/filters/mediaImage';
export default class ChangeSetThumbnail {
    config() {
        return {
            title: 'Change collection thumbnail',
            description: 'Select an image to replace the current collection thumbnail',
            mode: 'single',
            media: true,
            sets: false,
            upload: {
                allow: true,
                allowMultiple: false,
                newVersion: false,
                newSetThumbnail: true,
                allowedFileTypes: ['image'],
                onProcessFile: this.processFile,
                onProcessFiles: this.uploadComplete,
            },
            defaultFilters: [{ type: 'image' }, { interactive_id: null }, { public: null }],
            filterOptions: mediaImageFilters,
        };
    }
    processFile(file) {
        // no scope here
        return new Promise((resolve, reject) => {
            const serverJson = JSON.parse(file.serverId).data;

            const item = App.$store.getters.getMediaSetItem;
            item.url = file.getFileEncodeDataURL();

            App.$store.dispatch('hideMediaSelectModal').then(() => {
                ca.notify({
                    icon: 'edit',
                    type: 'success',
                    message: `${serverJson.title} added as a new thumbnail.`,
                    timeout: ca.config('toast.timeout'),
                });

                resolve(item);
            });
        }).catch((error) => {
            console.log(error);
        });
    }
    uploadComplete() {
        App.$store.commit('setMediaSelectModalCurrentView', 'MediaSelect');
        App.$store.commit('setMediaSelectIsLoading', true);
        App.$store.commit('setMediaSelectLoadingMessage', 'Your upload is processing...');
    }
    doAction() {
        console.log('ChangeSetThumbnail::doAction()');
        const options = App.$store.getters.getMediaSelectOptions;
        const item = App.$store.getters.getMediaSelectCurrentSelection;

        return new Promise((resolve) => {
            App.$store.dispatch('updateSet', { id: options.itemId, data: { media_id: item.id } }).then((response) => {
                resolve(response);
            });
        });
    }
}
